import AreaForm from "@/components/areas/AreaForm";
import Header from "@/components/Header";
import { appConfig } from "@/lib/AppConfig";
import { ValidationError } from "@/types/problemDetails";
import type { LayoutContext } from "@/lib/models";
import { AreaService, type Area } from "@/services/AreaService";
import { CacheService } from "@/services/CacheService";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

const AreaEditPage: React.FC = () => {
  const params = useParams();
  const [areaName, setAreaName] = useState("");
  const [areaData, setAreaData] = useState<Area | null>(null);
  const { setPageName } = useOutletContext<LayoutContext>();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const area = await AreaService.getById(params.areaId!);
        setAreaData(area);
        setPageName(`Area: ${area.name}`);
        setAreaName(area.name);
      } catch (error) {
        console.error('Fetch failed:', error);
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.areaId]);

  const onSubmit = async (formData: Omit<Area, "id">) => {
    if (!params.areaId) {
      alert('error invalid areaId')
      return null
    }
    const updatedArea: Area = {
      id: params.areaId!, // Simple ID generation; use UUID in production
      ...formData,
    };

    try {
        await AreaService.update(params.areaId!, updatedArea);
        setAreaName(formData.name)
        CacheService.clear(appConfig.resourceTypes.area, updatedArea.id);
    } catch (error) {
        if (error instanceof ValidationError) {
            return error.errors;
        }
    }
    return null;
  };

  return (
    <div className="container mx-auto p-4">
      <Header headerTitle={areaName ? `Area: ${areaName}` : ""} />
      <AreaForm onSubmit={onSubmit} initialData={areaData as Area} />
    </div>
  );
};

export default AreaEditPage;
